import React, { useEffect } from 'react'
import MobileCategoryDrawer from './MobileCategoryDrawer';
import { defaultProductImage, NavLink, useDispatch, useSelector } from "../../../imports/generalImport";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "../../../imports/muiImport";
import { categoryUrl } from '../../../shared/extra';
import MobileLoading from '../mobileLoading/MobileLoading';
import MobileSectionTitle from '../mobileProductCard/MobileSectionTitle';
import { fetchCategories } from '../../../store/category/action';

const dummyCategoryData = [
    {
        "id": 2,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/hxB74MvsrnXNWvDyBDVfZ9lWnJK6FC2uFVwv4zyh.png",
        "title": "Apparel"
    },
    {
        "id": 3,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/ApVr6FFZ0jqdCfEvi8296peM6xWkHTfMznJp1FdA.png",
        "title": "Footwear"
    },
    {
        "id": 4,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/BF3LXVbrAR0xUlsKeYUx6Xq8JlGKi8poNiyq0iac.png",
        "title": "E-Commerce"
    },
    {
        "id": 5,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/tHzyPG2v12HJX6EJTtInIaXvFbrubQm5krRWrEkm.png",
        "title": "Accessories"
    },
    {
        "id": 6,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/gBXT9SKuHv9VXxyKbLaSPszCJsmVDW8SzghX59wI.png",
        "title": "Entertainment"
    },
    {
        "id": 7,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/UdI9zgfFEgeX3LpmPhYIwLt0cnOOJ7CGeRRzfBcU.png",
        "title": "Food"
    },
    {
        "id": 8,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/ENV4xJWrJ1M9PBxXe04lADi1nfZ87yB9pzKiDq5X.png",
        "title": "Gifting"
    },
    {
        "id": 9,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/ll7OE27LtXO6F2hZ4WC1IN9bjmdgjXEmUfoQn1QL.png",
        "title": "Grocery"
    },
    {
        "id": 10,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/yUjvbVocrYoYmNFvbhxZDSd7amRs3jCicUFPxsNI.png",
        "title": "Health"
    },
    {
        "id": 12,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/TOVe4YycDd3KtACpit2IbAhxJRhohmQUXpLiYGxR.png",
        "title": "Jewellery"
    },
    {
        "id": 13,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/bm2iiSNPlMMLfwoF1TZw5MRJ2lSUol5IwyQlUUI1.png",
        "title": "Electronics"
    },
    {
        "id": 14,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/o0mjuoNkw0NesoGLxlX6kg2jfVyEFMP1gIhy10pQ.png",
        "title": "OTT"
    },
    {
        "id": 21,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/mHTQq6VIGZPa4H8SESklp0R5alh2NhnACvJ10n4X.png",
        "title": "Travel"
    },
    {
        "id": 34,
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/oxgTZ6j1hWavixIIk1rToY1vQPYOU2SeXTTq8zN3.png",
        "title": "Furniture"
    }
]

export default function MobileHomeCategory() {
    const theme = useTheme();
    const [loading, setLoading] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const navbarCategory = useSelector((state) => state?.Category?.categories);

    const visibleCategoryCount = useMediaQuery(theme.breakpoints.down('sm')) ? 8 : 12;
    const dispatch = useDispatch();


    useEffect(() => {
        if (navbarCategory) {
            setLoading(false);
        } else {
            dispatch(fetchCategories());
        }
    }, [navbarCategory, loading])

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const customBtnHandler = () => {
        setOpen(!open);
    }

    return (
        <>
            <MobileCategoryDrawer open={open} setOpen={setOpen} toggleDrawer={toggleDrawer} />
            <Box sx={{
                p: 2,
            }}>
                <Box sx={{
                }}>

                    <Stack
                        sx={{
                            mb: 2,
                        }}
                    >
                        <MobileSectionTitle
                            sectionTitle={"categories"}
                            buttonText={"view all"}
                            customBtnHandler={customBtnHandler}
                        />
                    </Stack>

                    {loading || !navbarCategory?.length ?
                        (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 240
                                }}>
                                <MobileLoading />
                            </Box>
                        )
                        :
                        (
                            <Box sx={{
                                display: "grid",
                                gridTemplateRows: "2,1fr",
                                gridTemplateColumns: {
                                    xs: "repeat(4,1fr)",
                                    sm: "repeat(6,1fr)"
                                },
                                rowGap: 2.5,
                                columnGap: 1.5,
                                overflow: 'hidden',
                            }}>
                                {navbarCategory
                                    ?.filter(item => item?.products?.length > 0)
                                    ?.slice(0, visibleCategoryCount)
                                    ?.map((item) => {
                                        return (
                                            <NavLink
                                                to={`card-list?category=${categoryUrl(item?.title)}`}
                                                key={`category-${item?.id * 1}`}
                                                style={{
                                                    textDecoration: "none",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}>
                                                    <Box
                                                        component="img"
                                                        src={item?.image || defaultProductImage}
                                                        width={60}
                                                        height={60}
                                                        sx={{
                                                            // borderRadius: "50%",
                                                            objectFit: "cover",
                                                            // p: "4px",
                                                            // border: "1px solid #deebff",
                                                        }}
                                                    />

                                                    <Typography variant='subtitle1' sx={{
                                                        width: "100%",
                                                        textAlign: "center",
                                                        color: "primary.main",
                                                        fontWeight: 400,
                                                        fontSize: "11.5px",
                                                        textDecoration: "none",
                                                    }}>
                                                        {item?.name}
                                                    </Typography>
                                                </Box>
                                            </NavLink>
                                        );
                                    })}
                            </Box>
                        )
                    }
                </Box>

            </Box>

        </>
    )
}
